module.exports = __webpack_public_path__ + "static/media/bell_pepper_img.f3fc3874.webp";